import type { DeviceType, WrapperType } from '@carboncopyco/types';
import classNames from 'classnames';
import type React from 'react';
import type { ReactElement } from 'react';

interface IWrapper {
  apply: boolean;
  children: ReactElement;
  wrapperType: WrapperType;
  screenResolutionType?: DeviceType;
  hideBorders?: boolean;
}

const circleClassName =
  'w-2.5 h-2.5 bg-ds-natural-50 rounded-full inline-block mr-1.5';

const DeviceWrapper: React.FC<IWrapper> = ({
  children,
  apply,
  wrapperType = null,
  screenResolutionType,
  hideBorders,
}) => {
  if (!apply || !screenResolutionType) {
    return children;
  }

  if (!wrapperType) {
    return (
      <div
        className={classNames('h-full', {
          'overflow-hidden shadow-ds-lg rounded-lg': !hideBorders,
        })}
      >
        {children}
      </div>
    );
  }

  // Device wrappers
  if (wrapperType === 'device') {
    switch (screenResolutionType) {
      case 'tablet':
      case 'mobile': {
        return (
          <div className={classNames(['relative w-fit h-full'])}>
            <div className="absolute top-[108px] left-0 h-[54px] w-[11px] bg-ds-natural-700 ml-[-6px] rounded-l-md" />
            <div className="absolute top-[172px] left-0 h-[54px] w-[11px] bg-ds-natural-700 ml-[-6px] rounded-l-md" />
            <div
              className={classNames(
                [
                  'h-full border-8 border-ds-natural-700 overflow-hidden shadow-ds-lg',
                ],
                screenResolutionType === 'tablet'
                  ? 'rounded-[20px]'
                  : 'rounded-[40px]'
              )}
            >
              {children}
            </div>
          </div>
        );
      }
      default:
        return children;
    }
  }

  // Browser wrappers
  return (
    <div
      className={classNames([
        'rounded-lg border-ds-natural-150 shadow-ds-lg overflow-hidden w-full h-full box-border flex flex-col bg-white',
      ])}
    >
      <div className="border-ds-natural-300 bg-ds-natural-300 h-10 relative flex items-center justify-start pl-4 pr-6 pt-2.5 pb-2 ">
        <div className="flex items-center mr-2.5">
          <span className={circleClassName} />
          <span className={circleClassName} />
          <span className={circleClassName} />
        </div>
      </div>
      {children}
    </div>
  );
};

export default DeviceWrapper;
